import { AxiosResponse } from 'axios';
import { useState } from 'react';
import BadgeSquare from '@/components/atoms/BadgeSquare';

import { CPLAT_API_ROUTES, useSuspenseFetchs } from '@/api';

import { useAppSelector } from '@/redux/store';

import { useSearchParams } from 'react-router-dom';
import type { RegisteredMarketInfo, MarketInfo } from '@/types/api';

import RegisteredMarketList from './Market/RegisteredMarketList';
import { HIDDEN_MARKET_ENG } from './Market/_constants/const';
import MarketMenuBoard from './Market/MarketMenuBoard';
import AlertDialog from '@/components/dashboard/alert-dialog';

const MarketPage = () => {
  const user = useAppSelector((state) => state.user);
  const [isOnBoradingModalOpen, setIsOnBoradingModalOpen] = useState<boolean>(false);
  const [isInstallModalOpen, setIsInstallModalOpen] = useState<boolean>(false);
  const [searchParams] = useSearchParams();
  const origin = searchParams.get('origin');

  const [
    { data: marketInfoRes },
    { data: registeredMarketRes, refetch: reFetchList },
    { data: registedMarketListArrayRes, refetch: reFetchReference },
  ] = useSuspenseFetchs([
    { url: CPLAT_API_ROUTES.getMarketModel, option: { method: 'POST' } },
    {
      url: CPLAT_API_ROUTES.getRegisteredMarketInfo,
      option: {
        method: 'POST',
        params: {
          cplatToken: user.CplatToken,
        },
      },
    },
    {
      url: CPLAT_API_ROUTES.getRegisteredMarketAccountStore,
      option: {
        method: 'POST',
        params: {
          cplatToken: user.CplatToken,
        },
      },
    },
  ]);

  const { data: marketInfoList } = marketInfoRes as AxiosResponse<MarketInfo[]>;
  const { data: registedMarketList } = registeredMarketRes as AxiosResponse<
    {
      RegisteredMarketList: RegisteredMarketInfo[];
    }[]
  >;

  const { data: registedMarketListArray } = registedMarketListArrayRes as AxiosResponse<
    {
      MarketStoreList?: any[];
    }[]
  >;

  const referenceMarketArray = registedMarketListArray[0]?.MarketStoreList || [];

  const isEmptyRegistedMarket = registedMarketList.length <= 0;
  const registerdData = registedMarketList[0]?.RegisteredMarketList || [];

  // 필터링
  const filteredMarketInfoList = marketInfoList.filter(
    (market) => !HIDDEN_MARKET_ENG.includes(market.MarketNameEnglish),
  );
  return (
    <div className="scrollbar flex min-h-full  w-full flex-1 flex-col gap-[16px] overflow-y-auto ">
      <AlertDialog />
      <div className="flex w-full max-w-full flex-1 flex-col gap-[16px]  p-[40px] px-[60px]">
        <div className="flex w-full flex-col gap-[16px]  text-gr-900 Title2S24">마켓 관리</div>
        <div className="grid grid-cols-1  gap-[20px] md:grid-cols-2">
          <div className="cols-span-1 overflow-x-auto">
            <RegisteredMarketList
              reFetchList={reFetchList}
              reFetchReference={reFetchReference}
              marketInfoList={filteredMarketInfoList}
              referenceMarketArray={referenceMarketArray}
              registeredMarketList={registerdData}
              isEmptyRegistedMarket={isEmptyRegistedMarket}
            />
          </div>
          <div className="cols-span-1 overflow-x-auto">
            <div className="flex flex-col gap-4">
              <div className="flex justify-between">
                <div className="text-gr-900 Body1S16">연동 가능한 마켓</div>
                <div className="flex items-center gap-[9px]">
                  <BadgeSquare variant={'purple'} size="plusBadge" className="">
                    PLUS
                  </BadgeSquare>
                  <div className="text-gr-800 Body5M14">상품 발송 및 문의글 처리가 가능해요</div>
                </div>
              </div>

              <MarketMenuBoard marketInfoList={filteredMarketInfoList} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarketPage;

// <Suspense fallback={<GlobalSpinner />}>
//   <h1 className="mb-[30px] text-gr-800 c-t2">
//     {user.StoreName}님 환영합니다!
//     <br />
//     PC에서 편하게 마켓 연동을 진행해 보세요
//   </h1>
//   <MarketInfoContainer
//     registedMarketList={
//       isEmptyRegistedMarket ? [] : registedMarketList[0].RegisteredMarketList
//     }
//     marketInfoList={marketInfoList}
//     isEmptyRegistedMarket={isEmptyRegistedMarket}
//   />

//   {/* 온보딩 모달 */}
//   <Dialog
//     open={isOnBoradingModalOpen}
//     onOpenChange={() => {
//       setIsOnBoradingModalOpen(false);
//     }}
//   >
//     <DialogContent className="flex flex-col items-center gap-0 p-[30px] pb-[20px] text-center">
//       <div className="mb-[40px] flex flex-col gap-[16px] text-start">
//         <h1 className="text-gr-900 Title3S18">
//           {`안녕하세요 ${user.StoreName}님, 셀러박스 회원가입이 완료되었어요 🎉`}
//           <br />
//           셀러박스 PC에서 제공하는 기능들을 확인해 보세요!
//         </h1>
//         <div>
//           <div className="ml-[4px] flex items-center gap-[4px]">
//             <h2 className="text-gr-700 Body1S16">1.</h2>
//             <h2 className="text-gr-700 Body1S16">마켓 연동</h2>
//           </div>
//           <p className="text-gr-700 Body5M14">
//             큰 화면에서 편리하게 운영중인 마켓을 모두 연동할 수 있어요
//           </p>
//         </div>
//         <div>
//           <div className="ml-[4px] flex items-center gap-[4px]">
//             <h2 className="text-gr-700 Body1S16">2.</h2>
//             <h2 className="text-gr-700 Body1S16">상품 발송</h2>
//           </div>
//           <p className="text-gr-700 Body5M14">
//             연동한 마켓에 발생한 신규 주문건의 상세 내역을 확인하고 발송 처리할 수 있어요
//           </p>
//         </div>
//         <img src={OnBoardingModal} loading="lazy" />
//       </div>
//       <Button
//         variant={'secondary'}
//         onClick={() => {
//           setIsInstallModalOpen(true);
//         }}
//         className="h-[44px] w-[200px] rounded-sm Body3S15"
//       >
//         다음
//       </Button>
//     </DialogContent>
//   </Dialog>
//   <Dialog
//     open={isInstallModalOpen}
//     onOpenChange={() => {
//       setIsInstallModalOpen(false);
//     }}
//   >
//     <DialogContent className="items-left gap-0 p-[30px] pb-[20px] text-start">
//       <h1 className="text-gr-900 Title3S18">
//         셀러박스 앱을 설치하고 더 많은 기능을 사용해 보세요!
//       </h1>
//       <div className="mb-[36px] mt-[22px] flex">
//         <div className="flex w-[350px] flex-col gap-[16px]">
//           <div>
//             <h2 className="text-gr-700 Body1S16">실시간 알림 발송</h2>
//             <p className="text-gr-600 Body5S14">
//               마켓의 신규 주문을 수집하고 실시간으로 알림을 발송해 드려요
//             </p>
//           </div>
//           <div>
//             <h2 className="text-gr-700 Body1S16">리뷰 수집 및 답변 작성</h2>
//             <p className="text-gr-600 Body5S14">
//               작성된 리뷰의 내용을 AI가 분석하고 알맞은 답변을 생성해요
//             </p>
//           </div>
//         </div>
//         <div className="flex flex-col gap-[16px]">
//           <div>
//             <h2 className="text-gr-700 Body1S16">상품 발송 처리</h2>

//             <p className="text-gr-600 Body5S14">
//               언제 어디서나 모바일로 간편하게 상품의 발송을 처리할 수 있어요
//             </p>
//           </div>
//           <div>
//             <h2 className="text-gr-700 Body1S16">상품 모니터링</h2>

//             <p className="text-gr-600 Body5S14">
//               검색 키워드 별 상품의 노출 순위를 매일 모니터링해 드려요
//             </p>
//           </div>
//         </div>
//       </div>
//       <img src={InstallModal} loading="lazy" />
//       <div className="flex gap-[10px] justify-self-center">
//         <Button
//           variant={'secondary'}
//           onClick={() => {
//             setIsInstallModalOpen(false);
//           }}
//           className="mt-[40px] h-[44px] w-[145px] rounded-sm	Body3S15"
//         >
//           이전
//         </Button>
//         <Button
//           variant={'default'}
//           onClick={() => {
//             setIsOnBoradingModalOpen(false);
//             setIsInstallModalOpen(false);
//           }}
//           className="mt-[40px] h-[44px] w-[145px] rounded-sm	Body3S15"
//         >
//           확인
//         </Button>
//       </div>
//     </DialogContent>
//   </Dialog>
// </Suspense>
